/**
 * Project : workspace
 * File    : DownloadAppRow.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.homepage.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import component.button.DownloadAppButton
import graph.PlatformType
import theme.ThemeColor

@Composable
/**
 * Executes the download app row operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
fun downloadAppRow() {
    val uriHandler = LocalUriHandler.current

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .wrapContentHeight()
            .padding(top = 20.dp)
            .background(brush = Brush.horizontalGradient(
                    ThemeColor.shared().downloadRowBackground
                ),
            ),
    ) {
        DownloadAppButton(platformType = PlatformType.Android)
        DownloadAppButton(platformType = PlatformType.iOS)
        DownloadAppButton(platformType = PlatformType.Mac)
        DownloadAppButton(platformType = PlatformType.Windows)
    }
}